import { ChangeDetectionStrategy, Component } from "@angular/core";

@Component({
    selector: "app-azara-wrapper",
    templateUrl: "./azara-wrapper.component.html",
    styleUrl: "./azara-wrapper.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AzaraWrapperComponent {}
